
window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  $( ".deck-tech-slides-sortable" ).sortable({ handle: ".drag-handle"});

  $(".deck-techs-add-card" ).bind( "click", function() {
    var nodes = $("#deck-tech-slide-new-card-insertion").clone();
    nodes.children().insertBefore("#deck-tech-slide-new-slide-insertion");
		rebindAutocomplete();
  });
  $(document).on('click', '.deck-techs-add-card-to-slide', function (e) {
    var cloneable =  $(this).closest(".deck-tech-slide").find(".cloneable-card");
    for (var i = 0; i < 4; i++) {
      var nodes = cloneable.clone();

      nodes.removeClass("cloneable-card");
      nodes.insertBefore(cloneable);
    }
		rebindAutocomplete();
  });

  $(".deck-techs-add-deck" ).bind( "click", function() {
    var nodes = $("#deck-tech-slide-new-deck-insertion").clone();
    nodes.children().insertBefore("#deck-tech-slide-new-slide-insertion");
		rebindAutocomplete();
  });

  $(".deck-techs-add-image" ).bind( "click", function() {
    var nodes = $("#deck-tech-slide-new-image-insertion").clone();
    nodes.children().insertBefore("#deck-tech-slide-new-slide-insertion");
  });

  $('.deck-techs-form').submit(preprocessForm);

  $(document).on("click", ".deck-techs-slide-delete-icon", function() {
    $(this).closest(".row").hide();
    $(this).closest(".row").find(".deck-techs-slide-delete").prop('checked', true);
  });

	$('#deck_input_specific_cards').change(function() {
		rebindAutocomplete();
	}); 

});


var preprocessForm = function() {
  var i=0;
  $('.deck-techs-form .deck-tech-slide').each(function() {
    var node = $(this);
    node.find(".deck-tech-slide-position").val(i);
    node.find(":input").each(function() {
      var input = $(this);
      var nameBefore = input.attr('name')
      if (Boolean(nameBefore)) {
        var nameAfter = input.attr('name').replace(/\[\d+\]/, "[" + i + "]");
        input.attr('name', nameAfter);
      }
    });
    i++;
  });
}

var rebindAutocomplete = function() {
	$('.autocomplete-card').each(function() {
		if ($(this).data('ui-autocomplete') != undefined) {
			$(this).autocomplete('destroy');
		}
	});

	if (document.getElementById('deck_input_specific_cards').checked) {
		bindSearchAutoComplete($('.autocomplete-card'), null, null, false);
	} else {
		bindAutoCompleteCard();
	}
}
window.rebindAutocomplete = rebindAutocomplete;
